export default __webpack_public_path__ + "static/media/execute_scheduledExam.69194d04.png";